import { SettingType } from 'src/type/settings';
import { UserLevelType } from 'src/type/user';

import { useState, useEffect } from 'react';
import { useBoolean } from 'src/hooks/use-boolean';
import axios, { endpoints } from 'src/utils/axios';
import { toastError } from 'src/utils/format-error';
import LoadingContainer from 'src/components/ui-kit/loading-container';
import SettingUserLevelFee from './setting-user-level-fee';
import SettingTxFee from './setting-tx-fee';

export default function SettingFee() {
  const initialize = useBoolean(true);
  const [settings, setSettings] = useState(Array<SettingType>());
  const [levelFee, setLevelFee] = useState(Array<UserLevelType>());

  const reload = useBoolean();

  useEffect(() => {
    load();
  }, [reload.value]);

  const load = async () => {
    try {
      const [systemSettingResponse, userLevelResponse] = await Promise.all([
        axios.get<SettingType[]>(endpoints.settings.get),
        axios.get<UserLevelType[]>(endpoints.userLevel.get),
      ]);
      setSettings(systemSettingResponse.data);
      setLevelFee(userLevelResponse.data);
    } catch (error) {
      toastError(error);
    } finally {
      initialize.onFalse();
    }
  };

  return (
    <LoadingContainer loading={initialize.value} sx={{ minHeight: '30vh' }} fitContent>
      <SettingTxFee settings={settings} forceReload={reload.onToggle} />
      <SettingUserLevelFee levelFee={levelFee} forceReload={reload.onToggle} />
    </LoadingContainer>
  );
}
